import { render, staticRenderFns } from "./audioFeedback.vue?vue&type=template&id=c23b836e&scoped=true"
import script from "./audioFeedback.vue?vue&type=script&lang=js"
export * from "./audioFeedback.vue?vue&type=script&lang=js"
import style0 from "./audioFeedback.vue?vue&type=style&index=0&id=c23b836e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c23b836e",
  null
  
)

export default component.exports